export * from './lib/new-leads.component';
